import { testimonials } from "@/mocks/siteData";

export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-4">
          <span className="w-2.5 h-2.5 rounded-full bg-accent-500"></span>
          <span className="text-xs font-semibold uppercase tracking-wider text-foreground-500">What Users Say</span>
        </div>
        <h2 className="text-3xl md:text-5xl font-heading font-extrabold text-foreground-950 leading-[1.15] mb-4">
          Trusted By Thousands
          <br />
          Of Smart Shoppers
        </h2>
        <p className="text-sm md:text-base text-foreground-500 mb-12 max-w-lg">
          Real feedback from real users who use the Superbuy Spreadsheet every day.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t, idx) => (
            <div
              key={t.name}
              className={`p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200 transition-all duration-300 hover:-translate-y-1 ${
                idx === 5 ? "opacity-75" : ""
              }`}
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${
                      i < t.rating ? "ri-star-fill text-accent-500" : "ri-star-fill text-foreground-200"
                    }`}
                  ></i>
                ))}
              </div>
              <h4 className="text-base font-bold text-foreground-950 mb-3">{t.title}</h4>
              <p className="text-sm text-foreground-600 leading-relaxed mb-5">{t.content}</p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{t.name}</div>
                  <div className="text-xs text-foreground-500">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}